import { jsx as e } from "react/jsx-runtime";
import o from "styled-components";
import r from "../../../../utils/colors.js";
const n = o.li`
  font-size: 1rem;
  text-align: center;
  cursor: pointer;
  padding-top: 12px;
  padding-bottom: 12px;
  display: flex;
  flex-direction: column;
  justify-content: stretch;

  &:hover,
  &:focus {
    background-color: ${r.blueGrey};
  }
`, i = o.a`
  color: ${r.white};
  text-align: left;
  padding-left: 24px;
  min-height: 30px;
  line-height: 26px;
  text-decoration: none;
`, d = ({ item: t }) => /* @__PURE__ */ e(n, { children: /* @__PURE__ */ e(i, { target: "_self", href: t.href, children: t.text }) }, t.id);
export {
  d as default
};
